var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactusTouchLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 42,
    viewBox: "0 0 29 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.5C7.05794 1.5 1 7.47075 1 14.8504C1 19.0426 3.19781 24.3044 5.66677 28.9345C8.1602 33.6104 11.0345 37.8286 12.5769 39.9926C12.793 40.2996 13.0781 40.5531 13.4118 40.7294C13.7469 40.9066 14.1199 41 14.5 41C14.8801 41 15.2531 40.9066 15.5883 40.7294C15.9219 40.5531 16.2071 40.2996 16.4231 39.9926C17.9655 37.8294 20.8398 33.6129 23.3332 28.9376C25.8023 24.3079 28 19.0457 28 14.8504C28 7.47075 21.9421 1.5 14.5 1.5Z",
    stroke: "#3F7D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22.25C17.8137 22.25 20.5 19.5637 20.5 16.25C20.5 12.9363 17.8137 10.25 14.5 10.25C11.1863 10.25 8.5 12.9363 8.5 16.25C8.5 19.5637 11.1863 22.25 14.5 22.25Z",
    stroke: "#3F7D20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactusTouchLocationIcon);
export default __webpack_public_path__ + "static/media/contactus_touch_location_icon.abd6cb0ed782e9adc31d01d8b883a547.svg";
export { ForwardRef as ReactComponent };